module.exports = __webpack_public_path__ + "img/Feature.f5ffe32f.png";